import React, {FunctionComponent, useContext, useEffect, useMemo, useState} from 'react';
import {Context} from "../../store/context";
import {RouteChildrenProps} from "react-router";
import TranslatedText from "../../components/ui/TranslatedText/TranslatedText";
import UITranslations from "../../store/uiTranslations";
import SwitchControl from "../../components/PathFinder/PathFinderControls/SwitchControl/SwitchControl";
import {Grid, MuiThemeProvider, Paper, TextField, Typography} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import {observer} from "mobx-react";
import Splash from "../../components/ui/Splash";
import GettingToWizard from "../../components/GettingToPage/GettingToWizard/GettingToWizard";
import {createMuiTheme} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {ILanguage} from "../../types/ILanguage";
import LanguageDropdown from "../../components/ui/LanguageDropdown/LanguageDropdown";
import FormControl from "@material-ui/core/FormControl";
import blue from "@material-ui/core/colors/blue";
import NotFound from "../../components/ui/NotFound/NotFound";

const theme = createMuiTheme({
    overrides:{
        MuiLink: {
            root:{
                color: blue[600]
            }
        },
        MuiGrid:{
            "grid-xs-12": {
                flexBasis:"auto"
            }
        }
    }
});

const useStyles = makeStyles(theme => ({
    gettingToPage__question:{
        marginBottom:"1rem"
    },
    gettingToPage__languageDropdown:{
        width: '40%',
        minWidth:"125px"
    },
    gettingToPage:{
        padding: theme.spacing(2)
    }
}));

type Props = RouteChildrenProps;

const GettingToPage:FunctionComponent<Props> = (props)=> {
    const ui = UITranslations.GettingToPage;
    const classes = useStyles();

    const {gettingToPageStore, languagesStore} = useContext(Context);
    const [arrivingByCar, setArrivingByCar] = useState(true);
    const [parkTheCar, setParkTheCar] = useState(true);

    useEffect(() => {
        gettingToPageStore.setQuery(props.location.search);

        return gettingToPageStore.dispose;
    }, [])

    useEffect(() => {
        if (!arrivingByCar)
            setParkTheCar(false);
    }, [arrivingByCar]);

    if(!gettingToPageStore.queryParams.isValid || gettingToPageStore.settings === null)
        return <NotFound/>

    if (!languagesStore.currentIETF)
        return <Splash/>

    const handleLanguageChange = (ietf) =>{
        gettingToPageStore.setLanguage(ietf);
    }

    return <MuiThemeProvider theme={theme}>
        <Paper classes={{root:classes.gettingToPage}}>
            <Grid container direction="column">
                <Typography classes={{root:classes.gettingToPage__question}}>
                    <strong><TranslatedText source={ui.HeaderQuestion}/></strong>
                </Typography>
                <Grid item container xs={12} sm={6} md={4} justify="flex-end">
                    <SwitchControl checked={arrivingByCar}
                                   onChange={(checked) => setArrivingByCar(checked)}
                                   label={<TranslatedText source={ui.ArrivingByCar}/>}
                                   labelPlacement="start"/>
                </Grid>
                <Grid item container xs={12} sm={6} md={4} justify="flex-end">
                    <SwitchControl checked={parkTheCar}
                                   onChange={(checked) => setParkTheCar(checked)}
                                   label={<TranslatedText source={ui.ParkTheCar}/>}
                                   labelPlacement="start"
                                   disabled={!arrivingByCar}/>
                </Grid>
                <Grid item container xs={12} sm={6} md={4} justify="flex-end">
                    <FormControl classes={{root:classes.gettingToPage__languageDropdown}}>
                        <LanguageDropdown onChange={handleLanguageChange}/>
                    </FormControl>
                </Grid>
                <hr/>
                <Grid item container xs={12}>
                    <GettingToWizard parkTheCar={parkTheCar}/>
                </Grid>
            </Grid>
        </Paper>
    </MuiThemeProvider>
}

export default observer(GettingToPage);
